import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import React from "react";
import AppTheme from "Theme/AppTheme";
import AuthPage from "./AuthPage";
import ForgotPassword from "./ForgotPassword";

function ForgotPasswordUser() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AppTheme}>
                <CssBaseline />
                <AuthPage
                    title="Forgot Your Password?"
                    subtitle="Enter the username you use with Authenticx and we'll send you instructions to reset your password."
                    shouldShowLogo={false}
                    header={
                        <AcxButton
                            component="a"
                            href={`/authentication/login?returnUrl=${encodeURI(
                                origin,
                            )}/app`}
                            color="white"
                            sx={(theme) => ({
                                color: theme.palette.gray[500],
                                border: "none",
                                fontSize: "14px",
                                p: theme.spacing(1, 2, 1, 0.5),
                                height: "36px",
                            })}
                            startIcon={<KeyboardArrowLeftRoundedIcon />}
                        >
                            Back
                        </AcxButton>
                    }
                >
                    <ForgotPassword />
                </AuthPage>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default ForgotPasswordUser;
